import {Injectable} from '@angular/core';
import {NgxSpinnerService} from 'ngx-spinner';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  private activeRequests: number = 0;

  //controlar mensagem spinner
  private mensagemSubject = new BehaviorSubject<string>('Carregando...');

  //observable mensagem
  mensagem$ = this.mensagemSubject.asObservable();

  constructor(private spinner: NgxSpinnerService) {}

  //mostrar spinner
  show(mensagem: string = 'Carregando...') {
    this.activeRequests++;

    //atualizar mensagem
    this.mensagemSubject.next(mensagem);

    //mostrar spinner
    this.spinner.show();
  }

  //atualizar apenas mensagem
  updateMessage(mensagem: string) {
    this.mensagemSubject.next(mensagem);
  }

  //ocultar spinner
  hide() {
    this.activeRequests--;

    //verificar requisições ativas
    if (this.activeRequests <= 0) {
      this.activeRequests = 0;
      //ocultar spinner
      this.spinner.hide();

      //limpar mensagem
      this.mensagemSubject.next('');
    }
  }
}
